import { mapGetters, mapActions } from 'vuex';
import Partials from '../components/partials';

export default {
	components: {
		...Partials
	},

	filters: {
		formattedDate(value) {
			let date = moment(value);
			return date.isValid() ? date.format('ddd Do MMM, YYYY') : value;
		},

		formattedDateTime(value) {
			let date = moment(value);
			return date.isValid() ? date.format('ddd Do MMM, YYYY hh:mm:A') : value;
		},

		/**
		 * Get the first letter of the value passed.
		 * 
		 * @param  {String} $value
		 * @return {String}       
		 */
		firstLetter($value) {
			return $value.toString().toUpperCase().charAt(0);
		}
	},

	computed: {
		...mapGetters({
			getRegions: 'Regions/getAll',
			getCities: 'Cities/getAll',
			getTowns: 'Towns/getAll'
		}),
	},

	methods: {
		...mapActions({
			loadRegions: 'Regions/all',
			loadCities: 'Cities/all',
			loadTowns: 'Towns/all',
			showLoader: 'showLoader',
			hideLoader: 'hideLoader',
			setBodyClass: 'setBodyClass'
		}),

		setCurrentBodyClass() {
			if (this.$route.name === 'location') {
				this.setBodyClass('location-page');
			} else {
				this.setBodyClass('index-page');
			}
		},

		loadAllRegions() {
			let notification;

			return this.loadRegions()
				.catch((error) => {
					this.buildErrorMessages(error)
						.then((data) => {
							notification = {
								message: data,
								type: 'danger'
							};

							this.notify(notification);
						});
				});					
		},

		loadAllCities(region) {
			let notification;
			let query = region ? {region_id: region} : {};

			return this.loadCities(query)
				.then((response) => {
					return Promise.resolve(response);
				})
				.catch((error) => {
					this.buildErrorMessages(error)
						.then((data) => {
							notification = {
								message: data,
								type: 'danger'
							};

							this.notify(notification);
						});

					return Promise.reject(error);
				});
		},		

		/**
		 * Load all towns
		 */
		loadAllTowns(city) {
			let notification;
			let query = city ? {city_id: city} : {};

			return this.loadTowns(query)
				.then((response) => {
					return Promise.resolve(response);
				})
				.catch((error) => {
					this.buildErrorMessages(error)
						.then((data) => {
							notification = {
								message: data,
								type: 'danger'
							};

							this.notify(notification);
						});

					return Promise.reject(error);
				});
		},

		/**
		 * This action is used to show a notification. It accepts an object
		 * which sets the notification style and also the notification message
		 */
		notify(notification) {
			$.notifyClose();

	    	$.notify({
	        	icon: "fa fa-bell",
	        	message: notification.message
	        }, {
	            type: notification.type,
	            timer: 2000,
	            placement: {
	                from: 'top',
	                align: 'center'
	            },
				animate: {
					enter: 'animated fadeInDown',
					exit: 'animated fadeOutUp'
				},	        
			});	
	    },

	    /**
	     * This function gets an errors array or object and then builds it into 
	     * a suitable in order for it to be used as a notification
	     */
	    buildErrorMessages(errors) {  
	    	console.log(errors);
	    		
	        if (errors.errors) {
	            errors = errors.errors;
	        } else if (errors.msg) {
	            errors = ['Sorry, the form validation failed. Fix all field errors.'];
	        }else if (errors.error) {
	        	errors = [errors.error];
	        } else {
	            errors = ['Something unexpected happened.'];
	        }
	  
	    	let data = '<b>Error Alert:</b><br>';
	    	data += '<ul>';

	    	$.each(errors, function (index, error) {
	    		data += `<li>${error}</li>`;
	    	});

	    	data += '<ul>';

	    	return Promise.resolve(data);
	    }
	},

	mounted() {
		this.setCurrentBodyClass();
	}
}


// WEBPACK FOOTER //
// ./src/mixins/global.js